module.exports = __webpack_public_path__ + "static/media/(020033).c3b55246.jpg";